export enum TrainingConfigurationOption {
	Default,
	Custom,
}
